<script setup lang="ts">
defineProps<{ isActive?: boolean; to?: string }>();
const emit = defineEmits(["click"]);
</script>

<template>
  <NuxtLink
    v-if="to"
    :to
    :class="['nav-bar-item', isActive && 'nav-bar-item--active']"
    @click="emit('click')"
    ><slot
  /></NuxtLink>
  <button
    v-else
    :class="['nav-bar-item', isActive && 'nav-bar-item--active']"
    @click="emit('click')"
  >
    <slot />
  </button>
</template>

<style scoped lang="scss">
.nav-bar-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 3.2rem;
  margin-top: 1rem;
  padding: 0;
  font-weight: bold;
  font-size: 1rem;
  font-family: var(--font-family, sans-serif);
  line-height: 2rem;
  white-space: nowrap;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;

  &::after {
    position: absolute;
    right: 0;
    bottom: -6px;
    left: 0;
    display: block;
    width: 0;
    height: 2px;
    margin: 0 auto;
    background-color: var(--primary-red, #ff0038);
    transition: 0.2s;
    content: "";
  }

  &:hover,
  &--active {
    color: var(--primary-red, #ff0038);

    &::after {
      width: 100%;
    }
  }
}
</style>
